import React, { useMemo } from 'react';
import classNames from 'classnames';
import { isPlainObject, isString } from 'lodash';
import styles from './FormControlErrorMessage.scss';
import useTranslation from './Translations/useTranslation';
const PAIR_LENGTH = 2;
const isFormErrorMessagePair = (errorMessage) => Array.isArray(errorMessage) &&
    errorMessage.length === PAIR_LENGTH &&
    isString(errorMessage[0]) &&
    isPlainObject(errorMessage[1]);
const FormControlErrorMessage = ({ noMargin = false, errorMessage, className = '', isStatic = false, translateErrorMessage = true, }) => {
    const { t } = useTranslation();
    const message = useMemo(() => {
        if (isFormErrorMessagePair(errorMessage)) {
            return t(errorMessage[0], errorMessage[1]);
        }
        if (Array.isArray(errorMessage)) {
            return errorMessage
                .map(m => (translateErrorMessage ? t(m) : m))
                .join(', ');
        }
        if (!translateErrorMessage) {
            return errorMessage;
        }
        return t(errorMessage);
    }, [t, errorMessage, translateErrorMessage]);
    const positionClassNames = useMemo(() => ({
        [styles['message-position-static']]: isStatic,
        [styles['message-position-absolute']]: !isStatic,
    }), [isStatic]);
    return (<small className={classNames(styles.message, positionClassNames, className, {
        'mb-10': !noMargin,
        'no-margin': noMargin,
    })}>
      {message}
    </small>);
};
export default FormControlErrorMessage;
